import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ceshi4",
  "use": "icon-ceshi4-usage",
  "viewBox": "0 0 51.8 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 51.8 48\" id=\"icon-ceshi4\">\n<image style=\"overflow:visible;enable-background:new    ;\" width=\"800\" height=\"800\" xlink:href=\"G:\\10月16日\\icon\\号卡办理.png\" transform=\"matrix(8.425000e-02 0 0 8.125000e-02 -7.8 -8.515)\">\n</image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol